export type StageIndex = 1 | 2 | 3 | 4 | 5 | 6

export const ALL_STAGE_INDICES: readonly StageIndex[] = [1, 2, 3, 4, 5, 6]

export const STAGE_DEPENDENCIES: Readonly<Record<StageIndex, readonly StageIndex[]>> = {
  1: [],
  2: [1],
  3: [2],
  4: [3],
  5: [3],
  6: [3, 4, 5],
}

export function getTransitiveDependents(stageIndex: number): StageIndex[] {
  const dependents = new Set<StageIndex>()
  let frontier: number[] = [stageIndex]
  while (frontier.length > 0) {
    const next: number[] = []
    for (const stage of ALL_STAGE_INDICES) {
      if (dependents.has(stage)) continue
      if (STAGE_DEPENDENCIES[stage].some((dep) => frontier.includes(dep))) {
        dependents.add(stage)
        next.push(stage)
      }
    }
    frontier = next
  }
  return ALL_STAGE_INDICES.filter((s) => dependents.has(s))
}

export function getMissingPrerequisites(stageIndex: StageIndex, isStored: (stage: StageIndex) => boolean): StageIndex[] {
  return STAGE_DEPENDENCIES[stageIndex].filter((dep) => !isStored(dep))
}

export function formatStageList(stages: readonly number[]): string {
  if (stages.length === 0) return ''
  if (stages.length === 1) return `Stage ${stages[0]}`
  const head = stages.slice(0, -1).join(', ')
  return `Stages ${head} and ${stages[stages.length - 1]}`
}

export function formatMissingPrerequisiteError(stageIndex: number, missing: readonly number[]): string {
  const noun = missing.length === 1 ? 'result is' : 'results are'
  return `${formatStageList(missing)} ${noun} required to run Stage ${stageIndex}.`
}
